import { useEffect, useState } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import { Box, Card, CardHeader, IconButton, Stack } from "@mui/material";
import MaterialTypography from "../../../../components/MaterialTypography";
import { useNavigate, useParams } from "react-router-dom";
import { fetchDataById, putData } from "../../../../api/Services";
import { ArrowBack } from "@mui/icons-material";
import { MotorModelForm } from "../components/motorModelForm";
import { useLoading } from "../../../../components/Loading";
import { useSnackbar } from "../../../../context/popup";

const EditMotorModel = () => {

  const navigate = useNavigate();
  const { setCircleLoading } = useLoading();
  const { showSnackbar } = useSnackbar();
  const params = useParams();
  const paramId = params.id;

  const [modelData, setModelData] = useState({});
  
  useEffect(() => {
    const fetchData = async () => {
      if (paramId) {
        setCircleLoading(true);
        try {
          await fetchDataById(`/reference/motor/mmv/model/${paramId}`).then(
            (res) => {
              const responseData = res?.data;
              setModelData((prevData) => ({
                ...prevData,
                name: responseData?.name,
                vehicleCategory: {
                  label: responseData?.motorCategory?.keyName,
                  value: responseData?.motorCategory?.id,
                },    
                motorMake: {value: responseData?.make?.id, label: responseData?.make?.name},
                isActive: responseData?.isActive,

                nameStatus: responseData?.name ? "success" : "unchecked",
                vehicleCategoryStatus: responseData?.motorCategory?.id ? "success" : "unchecked",
                motorMakeStatus: responseData?.make?.id ? "success" : "unchecked",
              }));
            }
          );
        } catch (err) {
          console.error("Error Fetching Data",err);
          showSnackbar(err?.response?.data?.message,"error");
        } finally {
          setCircleLoading(false);
        }
      }
    };

    fetchData();
  }, [paramId]);


  const handleUpdateModel = async (modelData) => {
    const payload = {
      name: modelData?.name,
      motorCategoryId: modelData?.vehicleCategory?.value,
      motorMakeId: modelData?.motorMakeId,
      isActive: modelData?.isActive,
    };
    try {
      const response = await putData(
        `/reference/motor/mmv/model/${paramId}`,
        payload
      );

      const successResponse = response?.success;
      const responseMessage = response?.message;
      if (successResponse) {

        navigate("/motor-master/motor-MMV?tabState=model");
        showSnackbar(responseMessage,"success");
      } else {
        showSnackbar(responseMessage,"error");
      }
    } catch (error) {
      console.error("Error updating",error);
      showSnackbar(error?.response?.data?.message,"error");
    }
  };

  return (
    <DashboardLayout>
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="row" alignItems="center" spacing={1}>
                <IconButton onClick={() => window.history.back()}>
                  <ArrowBack />
                </IconButton>
                <Stack direction="column" spacing={0}>
                  <MaterialTypography variant="h5" fontWeight="medium">
                    Edit Model details
                  </MaterialTypography>
                  <MaterialTypography variant="caption" color="text">
                    Update Model Details here.
                  </MaterialTypography>
                </Stack>
              </Stack>
            </Stack>
          }
        />
        <Box>
          <MotorModelForm onsubmit={handleUpdateModel} viewData={modelData} />
        </Box>
      </Card>
    </DashboardLayout>
  );
};

export default EditMotorModel;
